import React from 'react';

import './DropdownSort.scss';

function DropdownSort({
  sortOptions, sortingHandler, sortLabel = 'Sort by:', selectedOption,
}) {
  return (
    <div className="mn_dropdownSort">
      <label htmlFor="mn_sortDropdown">{sortLabel}</label>
      <select
        className="mn_sortDropdown"
        name="mn_sortDropdown"
        id="mn_sortDropdown"
        onChange={e => sortingHandler(e, e.target.value)}
        defaultValue={selectedOption}
      >
        {sortOptions && sortOptions.map(sortItem => (
          <option key={sortItem.sortBy} value={sortItem.sortBy}>
            {sortItem.viewName}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DropdownSort;
